type ClassValue =
  | string
  | number
  | boolean
  | undefined
  | null
  | Record<string, boolean | undefined | null>;

/**
 * Utility for conditionally joining CSS class names together
 * @example cn('base-class', isActive && 'active', { 'text-red': hasError })
 */
export function cn(...classes: ClassValue[]): string {
  return classes
    .flatMap((cls) => {
      if (!cls) return [];
      if (typeof cls === 'string' || typeof cls === 'number') return [cls];
      if (typeof cls === 'object') {
        return (
          Object.entries(cls)
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .filter(([_, value]) => Boolean(value))
            .map(([key]) => key)
        );
      }
      return [];
    })
    .filter(Boolean)
    .join(' ');
}
